import { render, staticRenderFns } from "./OnboardingComplete.vue?vue&type=template&id=18f6b98a"
import script from "./OnboardingComplete.vue?vue&type=script&lang=js"
export * from "./OnboardingComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports